import { isMockMode, post, simulateDelay } from "../../api";

export interface UpdateFeatureRequest {
	featureId: string;
	code: string;
	name: string;
	description: string;
	defaultValue: boolean;
}

export const updateFeature = (req: UpdateFeatureRequest) => {
	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(50, () => testData);
	}

	return post(`products/updateFeature`, req);
};
